<template>
  <div class="requirements-container">
    <div
      class="requirements-list-container"
      v-if="requirements && requirements.length > 0"
      :class="{
        '--in-collect-container': theme && theme === 'collect-list',
      }"
    >
      <div
        tag="div"
        @click="onDetail(requirement)"
        :to="`/requirement/${requirement.id}`"
        class="grid__item-requirement"
        v-for="(requirement, index) in requirements"
        :key="index"
        :class="{
          'scroll-up-to hoverEffect upObj': theme !== 'collect-list',
        }"
      >
        <div class="requirement__inner">
          <img
            v-if="!$isMobile && requirement.store_type == 4"
            class="icon-shejiqiye"
            src="../../assets/images/icons/icon-shejiqiye.jpg"
            alt=""
          />
          <div
            class="status"
            :class="{
              '--done': requirement.status === 2,
            }"
          >
            {{
              requirement.status === 0 ? "需求进行中" : requirement.status === 2 ? "需求已解决" : ""
            }}
          </div>
          <template v-if="$isMobile">
            <div class="re-mobile-header-container">
              <div class="header__inner">
                <div class="header">
                  <img :src="requirement.user_avatar" alt="" />
                </div>
                <div class="user-info">
                  <p class="user-name">{{ requirement.user_name }}</p>
                  <p class="publish-time">
                    <strong>{{ requirement.ctime | parseTime("{d} {enm}") }}</strong>
                    {{ requirement.ctime | parseTime("{y}") }}
                  </p>
                </div>
              </div>
            </div>
            <div class="re-mobile-main-body-container">
              <div class="main-body__inner">
                <div class="content">
                  <span>{{ requirement.mold_name }}_</span> {{ requirement.content }}
                </div>
                <div class="content__img">
                  <img
                    class="lazyload img"
                    v-if="requirement.title_picture_url"
                    :src="requirement.title_picture_url | parseImage"
                    alt
                  />
                  <img
                    class="lazyload img"
                    v-else
                    src="http://api.material-online.cn/public/uploads/images/20220226/ea0c2239901741170988bf33d50880b0_thumb.jpg"
                    alt
                  />
                </div>
              </div>
            </div>
            <div class="re-mobile-footer-container">
              <div class="footer__inner">
                <div class="re-info__item">
                  <i class="view__icon icon icon-view"></i>
                  <p>{{ requirement.browsenums }}</p>
                </div>
                <div class="re-info__item">
                  <i class="view__icon icon icon-heart"></i>
                  <p>{{ requirement.collectnums }}</p>
                </div>
                <div class="re-info__item">
                  <i class="view__icon feedback__icon icon icon-reply"></i>
                  <p>{{ requirement.commentNum }}人反馈</p>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="item-requirement__cover">
              <div class="cover__wrapper">
                <i class="--signed" v-if="requirement.signed == 1">重点项目</i>
                <img
                  class="lazyload img"
                  v-if="requirement.title_picture_url"
                  :src="requirement.title_picture_url | parseImage"
                  alt
                />
                <img
                  class="lazyload img"
                  v-else
                  src="http://api.material-online.cn/public/uploads/images/20220226/ea0c2239901741170988bf33d50880b0_thumb.jpg"
                  alt
                />
              </div>
            </div>
            <div class="item-requirement__info">
              <div class="info__child">
                <div class="info__base">
                  <div class="publish">
                    <strong>{{ requirement.ctime | parseTime("{d} {enm}") }}</strong>
                    {{ requirement.ctime | parseTime("{y}") }}
                  </div>
                </div>
                <div class="info__content">
                  <span>{{ requirement.mold_name }}_</span>{{ requirement.content }}
                </div>
              </div>
              <div class="info__other info__child">
                <div class="other__author">
                  <img class="headpic" :src="requirement.user_avatar" alt />
                  <p>{{ requirement.user_name }}</p>
                </div>
                <div class="other__view">
                  <i class="view__icon icon icon-view"></i>
                  <p>{{ requirement.browsenums }}</p>
                </div>
                <div class="other__collect">
                  <i class="view__icon icon icon-heart"></i>
                  <p>{{ requirement.collectnums }}</p>
                </div>
                <div class="other__feedback" v-if="theme !== 'collect-list'">
                  <i class="feedback__icon icon icon-reply"></i>
                  <p>{{ requirement.commentNum }}人反馈</p>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <Empty hint="没有找到相关信息" v-else></Empty>
    <Pagination
      :demand_mold_id="demand_mold_id"
      :config="isShowPagination"
      class="component-pagination"
      v-if="isShowPagination && requirements && requirements.length > 0"
    ></Pagination>
  </div>
</template>

<script>
import Pagination from "@/components/pagination.vue";
import Empty from "@/pages/common/empty.vue";

export default {
  name: "requirement-list",
  components: {
    Pagination,
    Empty,
  },
  props: {
    requirements: {
      type: Array,
      default: () => [],
    },
    isShowPagination: {
      type: Object,
      default: null,
    },
    theme: {
      type: String,
      default: null,
    },
    demand_mold_id: {
      type: Number,
      default: 0,
    },
    hasChild: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onDetail(requirement) {
      console.log(requirement, 9);
      if (this.hasChild) {
        this.$emit("onChild", requirement.mold_id);
      } else {
        this.$router.push(`/requirement/${requirement.id || requirement.demand_id}`);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/_mixin";
.component-pagination {
  margin-top: px2vw(98 - 29);
}
.requirement__inner {
  position: relative;
  .icon-shejiqiye {
    position: absolute;
    right: 5.8vw;
    top: -0.28vw;
    width: 6vw;
    height: 3.3vw;
  }
}
</style>
